import React, { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Select, { components } from "react-select";
import Search from "../../components/Header/Search/Search";
import Pagination from "../../components/Pagination/Pagination";
import userRoleAuth from "../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../config/userRoles";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  useGetLocationList,
  useGetDepartmentList,
  useGetDesignationList,
} from "../../queries/employeeQueries";
import PageLoader from "../../components/PageLoader";
import EmployeeGenereratedPayrollData from "./EmployeeGenereratedPayrollData";
import {
  useGetEmployeePolicyPayrollList,
  useGenerateEmployeePayslipMutation,
} from "../../queries/payrollQuries";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { PAYROLL_STATUS } from "../../../src/redux/constants/payrollComponents";
import { useNavigate } from "react-router-dom";
const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <span className="ico-down text-blue-600"></span>
  </components.DropdownIndicator>
);

const DownloadEmployeePayslip = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const monthParam = searchParams.get("month");
  const yearParam = searchParams.get("year");

  const selectedMonth = monthParam ? Number(monthParam) : null;
  const selectedYear = yearParam ? Number(yearParam) : null;
  const user = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(user, userRoles.HR);
  const axiosPrivate = useAxiosPrivate();
  const searchRef = useRef();
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const [searchFilter, setFilter] = useState({
    payroll_status: PAYROLL_STATUS.PUBLISHED,
    page_no: 1,
    page_size: 10,
    filter: "",
    department: "",
    designation: "",
    office: "",
  });

  const { data: payrollData, isLoading } = useGetEmployeePolicyPayrollList({
    ...searchFilter,
    month: selectedMonth || "",
    year: selectedYear || "",
  });

  const employeeList = Array.isArray(payrollData?.data) ? payrollData.data : [];
  const totalRecords = Number(payrollData?.totalRecords) || 0;
  const totalPages = Number(payrollData?.totalPages) || 1;

  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);

  const isFiltered =
    searchFilter.filter ||
    searchFilter.department ||
    searchFilter.designation ||
    searchFilter.office;

  const handleClearFilters = () => {
    setFilter({
      payroll_status: PAYROLL_STATUS.PUBLISHED,
      page_no: 1,
      page_size: 10,
      filter: "",
      department: "",
      designation: "",
      office: "",
    });

    setSelectedDesignation(null);
    setSelectedDepartment(null);
    setSelectedOffice(null);
    if (searchRef.current) searchRef.current.value = "";
  };

  const defaultLocationOption = { location_name: "Office: All", id: null };
  const defaultDesignationOption = {
    designation_title: "Designation: All",
    id: null,
  };
  const defaultDepartmentOption = {
    department_name: "Department: All",
    id: null,
  };

  const { data: getLocationList } = useGetLocationList();
  const { data: getDepartmentList } = useGetDepartmentList();
  const { data: getDesignationList } = useGetDesignationList();
  const { mutate: generatePayslip } = useGenerateEmployeePayslipMutation();

  const departmentList = Array.isArray(getDepartmentList?.result)
    ? [defaultDepartmentOption, ...getDepartmentList.result]
    : [];

  const designationList = Array.isArray(getDesignationList?.result)
    ? [defaultDesignationOption, ...getDesignationList.result]
    : [];

  const locationList = Array.isArray(getLocationList?.result)
    ? [defaultLocationOption, ...getLocationList.result]
    : [];

  const handleSetFilter = (value, source) => {
    setFilter((prev) => ({
      ...prev,
      [source]: value,
    }));
  };

  const handleDownloadPayslip = async (employeeId,month,year) => {
    try {
      const response = await axiosPrivate.get(
        `/payroll/generateEmployeePayslip`,
        {
          params: { employee_id: employeeId , month: selectedMonth, year: selectedYear },
          responseType: "blob",
        }
      );

      const contentDisposition = response.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="?(.+)"?/);
      const fileName = fileNameMatch?.[1] || `payslip_${employeeId}.pdf`;

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to download payslip.");
    }
  };
const handleBulkDownload = async () => {
  if (selectedEmployees.length === 0) {
    toast.error("No employees selected for download");
    return;
  }

  toast.info("Bulk download started. Please wait...", { autoClose: 3000 });

  for (const employeeId of selectedEmployees) {
    if (employeeId) {
      await handleDownloadPayslip(employeeId);
    } else {
      toast.error("Invalid employee selected for download");
    }
  }

  toast.success("Bulk download completed!");
};


  return (
    <div className="w-full overflow-x-auto">
      <div className="px-10 py-6">
        <div className="flex justify-between items-center pb-4">
          <div>
            <h2>View Published Payrolls</h2>
            <p className="text-sm text-gray-500">Payroll Status Overview</p>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex gap-3 items-center">
            <Select
              value={selectedDesignation}
              onChange={(selected) => {
                setSelectedDesignation(selected);
                handleSetFilter(selected?.value, "designation");
              }}
              placeholder={"Designation: All"}
              options={designationList.map((i) => ({
                label: i.designation_title,
                value: i.id,
              }))}
              components={{ DropdownIndicator }}
              className="custom-select-container"
            />
            <Select
              value={selectedDepartment}
              onChange={(selected) => {
                setSelectedDepartment(selected);
                handleSetFilter(selected?.value, "department");
              }}
              placeholder={"Department: All"}
              options={departmentList.map((i) => ({
                label: i.department_name,
                value: i.id,
              }))}
              components={{ DropdownIndicator }}
              className="custom-select-container"
            />
            <Select
              value={selectedOffice}
              onChange={(selected) => {
                setSelectedOffice(selected);
                handleSetFilter(selected?.value, "office");
              }}
              placeholder={"Office: All"}
              options={locationList.map((i) => ({
                label: i.location_name,
                value: i.id,
              }))}
              components={{ DropdownIndicator }}
              className="custom-select-container"
            />

            {isFiltered && (
              <span
                className="text-blue-800 font-medium cursor-pointer"
                onClick={handleClearFilters}
              >
                Clear Filters
              </span>
            )}
          </div>

          <Search
            eleRef={searchRef}
            onChange={(e) => handleSetFilter(e, "filter")}
            value={searchFilter.filter}
          />
        </div>
      </div>

      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          <EmployeeGenereratedPayrollData
            employeeList={employeeList}
            selectedEmployees={selectedEmployees}
            setSelectedEmployees={setSelectedEmployees}
            month={selectedMonth}
            year={selectedYear}
            handleDownloadPayslip={handleDownloadPayslip}
          />

          <div className="flex justify-end gap-4 mt-6 px-10">
            <button
              className="btn btn--border text-sm font-medium"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            {selectedEmployees.length > 0 && (
            <button
  onClick={handleBulkDownload}
  className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded hover:bg-blue-700"
>
  Download Bulk Payslips
</button>
            )}
          </div>

          <div className="mt-[65px]">
            <Pagination
              page={{
                pageNo: searchFilter.page_no,
                setPageNo: (val) => handleSetFilter(val, "page_no"),
                pageSize: searchFilter.page_size,
                setPageSize: (val) => handleSetFilter(val, "page_size"),
                totalRecords: totalRecords,
                totalPages: totalPages,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default DownloadEmployeePayslip;
